import {useParams} from 'react-router-dom'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import styles from './RequestAbout.module.scss'
import {ProjectCard, Conditions} from 'modules/project'
import {
  RequestStatusPanel,
  RequestLoan,
  RequestDetails,
  RequestForecast,
  RequestSecurityItems,
  RequestOffer,
  RequestAML,
  ControllerReview,
  useGetRequest,
  isFirstManagerActionsChecked,
} from '..'

export default function RequestAbout() {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const params = useParams()
  const {data: request, isRefetching} = useGetRequest(params.uuid)

  const isShowReview = request.milestones.some(
    (milestone: any) => milestone.type === 'financial-reviewed'
  )

  const isShowOffer = request.milestones.some(
    (milestone: any) => milestone.type === 'offer-signed'
  )

  const isShowAML = request.milestones.some(
    (milestone: any) => milestone.type === 'aml-check-initiated'
  )

  return (
    <>
      <RequestStatusPanel />
      <div className={styles.content}>
        <ProjectCard
          project={request.project}
          request={request}
          isRequestLoading={isRefetching}
          imgHeight={206}
        />
        <div>
          <RequestLoan />
          <div className={styles.grid}>
            <div className={styles.column}>
              {isShowOffer && <RequestOffer />}
              {isShowReview && <ControllerReview />}
              <RequestDetails project={request.project} request={request} />
            </div>
            <div className={styles.column}>
              {isShowAML && <RequestAML />}
              { isFirstManagerActionsChecked(request) && 
                // (!!permissions?.includes('edit loan request (lm check)')) && 
                (<>
                  <RequestForecast />
                  <RequestSecurityItems />
                </>)
              }
              { !!permissions?.includes('add conditions') &&
              <Conditions
                requestView
                request={request}
                isRefetching={isRefetching}
              />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
